/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud
 * (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../lib/@waca/core-client/js/core-client/ui/properties/PropertyUIControl',
	'../../lib/@waca/core-client/js/core-client/utils/Deferred',
	'jquery',
	'react-dom',
	'../../lib/@waca/dashboard-common/dist/ui/CenterLoadingSpinner'
], function(View, PropertyUIControl, Deferred, $, ReactDOM, CenterLoadingSpinner) {
	var WidgetsPanelView = View.extend({
		init: function(options) {
			WidgetsPanelView.inherited('init', this, arguments);

			this.glassContext = options.glassContext;
			this.dashboardApi = options.dashboardApi;
			this.services = options.services;
			this.hooks = {
				getEntries: options.getEntries || Promise.resolve({})
			};

			this.whenIsReadyDfd = new Deferred();
			this._initialize();
		},

		whenIsReady: function() {
			return this.whenIsReadyDfd.promise;
		},

		setFocus: function() {
			this.$el.find('.itemOption:first').focus();
		},

		remove: function() {
			if(this._dropZone) {
				this._dropZone.remove();
			}
			WidgetsPanelView.inherited('remove', this, arguments);
		},

		render: function() {
			if(!this._$loadingIndicatorBlocker) {
				this._$loadingIndicatorBlocker = $('<div></div>');
			}
			this.$el.empty().addClass(this.className + ' widgetsPanelView');
			this.$el.append(this._$loadingIndicatorBlocker);
			ReactDOM.render(CenterLoadingSpinner({ size: 'normal', variant: 'circle' }), this._$loadingIndicatorBlocker[0]);

			return this.hooks.getEntries()
				.then(this._createPropertyControl.bind(this))
				.then(this.whenIsReady.bind(this))
				.then(()=>{
					this._dropZone = this._dndManager.addDropTarget(this.$el[0], { accepts: this._accepts.bind(this) });
				});
		},

		_initialize: function() {
			this._dndManager = this.dashboardApi.getFeature('DashboardDnd.internal');
			this.whenIsReadyDfd.resolve();
		},

		_createPropertyControl: function(spec) {
			spec.el = this.$el;
			spec.primaryUIControl = false;
			spec.glassContext = this.glassContext;

			var uiControl = new PropertyUIControl(spec);

			return Promise.try(function() {
				return uiControl.render()
					.then(() => {
						//this._ellipsifyLabels();
						ReactDOM.unmountComponentAtNode(this._$loadingIndicatorBlocker[0]);
						this._$loadingIndicatorBlocker.remove();
						this._$loadingIndicatorBlocker = null;
					});
			}.bind(this));
		},

		_accepts: function() {
			return true;
		}

	});

	return WidgetsPanelView;
});
